/** @font-face и font-family для HTML-письма (внешние woff2/otf на baseUrl). */
export function buildChecklistSalesEmailHeadStyles(baseUrl) {
  const root = baseUrl.replace(/\/$/, '');
  return `
<style type="text/css">
  @font-face {
    font-family: 'Even Mono';
    font-style: normal;
    font-weight: 400;
    src: url('${root}/fonts/even-mono/EvenMono-Regular.otf') format('opentype');
  }
  @font-face {
    font-family: 'Inter Display';
    font-style: normal;
    font-weight: 400;
    src: url('${root}/fonts/inter-display/InterDisplay-Email.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Inter Display';
    font-style: normal;
    font-weight: 700;
    src: url('${root}/fonts/inter-display/InterDisplay-Email-Bold.woff2') format('woff2');
  }
</style>`;
}

export const EMAIL_FONT_BODY = "'Inter Display',Arial,Helvetica,sans-serif";
export const EMAIL_FONT_MONO = "'Even Mono','Courier New',Courier,monospace";
